import { render, staticRenderFns } from "./DialogDetalhes.vue?vue&type=template&id=f699da64"
import script from "./DialogDetalhes.vue?vue&type=script&lang=js"
export * from "./DialogDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports